export const FETCHING_MENU_REQUEST = "FETCHING_MENU_REQUEST";
export const FETCHING_CATEGORY_REQUEST_SAGA = "FETCHING_CATEGORY_REQUEST_SAGA";
export const FETCHING_CATEGORY_REQUEST_SAGA_AFTER_CHECK =
  "FETCHING_CATEGORY_REQUEST_SAGA_AFTER_CHECK";
export const FETCHING_MENU_SUCCESS = "FETCHING_MENU_SUCCESS";
export const FETCHING_MENU_FAILURE = "FETCHING_MENU_FAILURE";
export const FETCHING_BY_STYLE_MENU_SUCCESS = "FETCHING_BY_STYLE_MENU_SUCCESS";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";

export const SET_PRODUCT_TYPE = "SET_PRODUCT_TYPE";

export const FETCHING_FEATURED_SUCCESS = "FETCHING_FEATURED_SUCCESS";
export const FETCHING_FEATURED_FAILURE = "FETCHING_FEATURED_FAILURE";
export const IS_MOBILE_CHECK = "IS_MOBILE_CHECK";
export const FETCHING_FEATURED_CATEGORY_SUCCESS =
  "FETCHING_FEATURED_CATEGORY_SUCCESS";
export const FETCHING_FEATURED_CATEGORY_NAME_CHANGE =
  "FETCHING_FEATURED_CATEGORY_NAME_CHANGE";

export const UNMOUNT_CATEGORY_PAGE = "UNMOUNT_CATEGORY_PAGE";

export const SET_CATEGORY_DISTANCE = "SET_CATEGORY_DISTANCE";
export const CATEGORY_UNMOUNT = "CATEGORY_UNMOUNT";
export const CATEGORY_FETCH_FLAG_SET = "CATEGORY_FETCH_FLAG_SET";
export const FETCHING_CATEGORY_SUCCESS = "FETCHING_CATEGORY_SUCCESS";
export const FETCHING_CATEGORY_FAILURE = "FETCHING_CATEGORY_FAILURE";
export const FETCHING_CATEGORY_NO_ITEM_FOUND =
  "FETCHING_CATEGORY_NO_ITEM_FOUND";
export const FETCHING_CATEGORY_REQUEST = "FETCHING_CATEGORY_REQUEST";
export const SET_FETCHED_CATEGORY_ITEMS_COUNT =
  "SET_FETCHED_CATEGORY_ITEMS_COUNT";
export const CHANGE_CATEGORY_NAME = "CHANGE_CATEGORY_NAME";
export const FETCHING_SEARCH_SUCCESS = "FETCHING_SEARCH_SUCCESS";
export const FETCHING_SEARCH_FAILURE = "FETCHING_SEARCH_FAILURE";
export const CHANGE_KEYWORD_NAME = "CHANGE_KEYWORD_NAME";

export const SET_SIGNIN_MESSAGE = "SET_SIGNIN_MESSAGE";

export const SET_SITE_DOWN_FOR_MAINTENANCE = "SET_SITE_DOWN_FOR_MAINTENANCE";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const UPDATE_LOGIN = "UPDATE_LOGIN";
export const USER_DATA_SUCCESS = "USER_DATA_SUCCESS";
export const USER_DATA_INITIAL = "USER_DATA_INITIAL";

export const SORTBYPARAMS_CHANGE_STATE = "SORTBYPARAMS_CHANGE_STATE";

export const FILTERURL_CHANGE_STATE = "FILTERURL_CHANGE_STATE";

export const FETCHING_FILTER_REQUEST = "FETCHING_FILTER_REQUEST";
export const FETCHING_FILTER_SUCCESS = "FETCHING_FILTER_SUCCESS";
export const FETCHING_FILTER_FAILURE = "FETCHING_FILTER_FAILURE";
export const FACET_CHANGE_BUTTONS_STATE = "FACET_CHANGE_BUTTONS_STATE";
export const UPDATE_FACET_BUTTONS_FOR_GROUPED_FACETS =
  "UPDATE_FACET_BUTTONS_FOR_GROUPED_FACETS";
export const SET_FACET_BREAD = "SET_FACET_BREAD";

export const SLIDER_MOVING = "SLIDER_MOVING";

export const CONFIRM_LEAVE = "CONFIRM_LEAVE";

export const NEXT_PAGE_ACTION = "NEXT_PAGE_ACTION";
export const DISPATCH_CURRENT_PAGE = "DISPATCH_CURRENT_PAGE";
export const DISPATCH_SCROOL_PAGE = "DISPATCH_SCROOL_PAGE";
export const NEXT_PAGE_SCROOL_ACTION = "NEXT_PAGE_SCROOL_ACTION";
export const LAST_PAGE = "LAST_PAGE";

export const SET_CHEQUE_VALIDATION_ERRORS = "SET_CHEQUE_VALIDATION_ERRORS";
export const SET_CHEQUE_VALIDATIONS = "SET_CHEQUE_VALIDATIONS";
export const SET_USER_INPUTS_PERSONALIZED_QUESTIONS =
  "SET_USER_INPUTS_PERSONALIZED_QUESTIONS";
export const SAVE_INPUTS = "SAVE_INPUTS";
export const SET_PERSONALZED_QUESTIONS_PROGRESS =
  "SET_PERSONALZED_QUESTIONS_PROGRESS";
  export const SET_DISCOUNT_STATE =
  "SET_DISCOUNT_STATE";
export const SET_PERSONALZED_QUESTIONS = "SET_PERSONALZED_QUESTIONS";
export const FETCH_BASKET_SUCCESS = "FETCH_BASKET_SUCCESS";
export const FETCH_SUPPLIERS_BASKET_SUCCESS = "FETCH_SUPPLIERS_BASKET_SUCCESS";

// export const ADD_HANDLER = "ADD_HANDLER";
export const SET_HANDLER = "SET_HANDLER";

export const GET_GEOLOCATION_COOKIE_REQUEST = "GET_GEOLOCATION_COOKIE_REQUEST";
export const GET_GEOLOCATION_COOKIE_SUCCESS = "GET_GEOLOCATION_COOKIE_SUCCESS";
export const GET_GEOLOCATION_COOKIE_FAILURE = "GET_GEOLOCATION_COOKIE_FAILURE";
export const CHANGE_GEOLOCATION = "CHANGE_GEOLOCATION";

export const SET_USER_LOCATION = "SET_USER_LOCATION";

export const SET_WISHLIST_MODAL_STATE = "SET_WISHLIST_MODAL_STATE";
export const FETCH_WISHLIST_SUCCESS = "FETCH_WISHLIST_SUCCESS";
export const TOGGLE_WISHLIST_SUCCESS = "TOGGLE_WISHLIST_SUCCESS";
export const WISHLIST_ADD_REDUX = "WISHLIST_ADD_REDUX";

export const TOGGLE_ITEM_COMPARE = "TOGGLE_ITEM_COMPARE";
export const DELETE_COMPARE_ITEM = "DELETE_COMPARE_ITEM";
export const CLEAR_COMPARE_ITEMS = "CLEAR_COMPARE_ITEMS";
export const REPLACE_COMPARE_ITEMS = "REPLACE_COMPARE_ITEMS";

export const GET_COMPARED_ITEM_DETAILS_REQUEST =
  "GET_COMPARED_ITEM_DETAILS_REQUEST";
export const GET_COMPARED_ITEM_DETAILS_SUCCESS =
  "GET_COMPARED_ITEM_DETAILS_SUCCESS";
export const GET_COMPARED_ITEM_DETAILS_FAILURE =
  "GET_COMPARED_ITEM_DETAILS_SUCCESS";
export const DELETE_COMPARED_ITEM_DETAILS = "DELETE_COMPARED_ITEM_DETAILS";
export const REPLACE_COMPARED_ITEM_DETAILS = "REPLACE_COMPARED_ITEM_DETAILS";

export const ADD_RECENT_VIEWED_ITEMS = "ADD_RECENT_VIEWED_ITEMS";

export const MESSAGE_CONTENT_REQUEST = "MESSAGE_CONTENT_REQUEST";
export const MESSAGE_CONTENT_CLOSE = "MESSAGE_CONTENT_CLOSE";
export const MESSAGE_CONTENT_SUCCESS = "MESSAGE_CONTENT_SUCCESS";
export const MESSAGE_CONTENT_FAILURE = "MESSAGE_CONTENT_FAILURE";

export const USER_MESSAGES_REQUEST = "USER_MESSAGES_REQUEST";
export const USER_MESSAGES_SUCCESS = "USER_MESSAGES_SUCCESS";
export const USER_MESSAGES_FAILURE = "USER_MESSAGES_FAILURE";

export const FETCH_COLLECTION_REQUEST = "FETCH_COLLECTION_REQUEST";
export const FETCH_COLLECTION_SUCCESS = "FETCH_COLLECTION_SUCCESS";
export const FETCH_COLLECTION_FAILURE = "FETCH_COLLECTION_FAILURE";

export const MESSAGE_IMAGE_URL_REQUEST = "MESSAGE_IMAGE_URL_REQUEST";

export const SET_BIID = "SET_BIID";
export const SET_LOADING_FOR_REVIEW_PROCESS = "SET_LOADING_FOR_REVIEW_PROCESS";
export const SET_JUMP_TO_REVIEW_TAB = "SET_JUMP_TO_REVIEW_TAB";

export const GET_ITEM_FETCH_REQUEST = "GET_ITEM_FETCH_REQUEST";
export const GET_ITEM_FETCH_SUCCESS = "GET_ITEM_FETCH_SUCCESS";
export const GET_ITEM_FETCH_FAILURE = "GET_ITEM_FETCH_FAILURE";
export const UNMOUNT_PRODUCT_PAGE = "UNMOUNT_PRODUCT_PAGE";
export const SET_REVIEW_MODAL_STATE = "SET_REVIEW_MODAL_STATE";
export const SUCECSS_MAIN_PRODUCT_SKUS_N_SKUIDS =
  "SUCECSS_MAIN_PRODUCT_SKUS_N_SKUIDS";
export const FAILURE_MAIN_PRODUCT_SKUS_N_SKUIDS =
  "FAILURE_MAIN_PRODUCT_SKUS_N_SKUIDS";
export const REQUEST_MAIN_PRODUCT_SKUS_N_SKUIDS =
  "REQUEST_MAIN_PRODUCT_SKUS_N_SKUIDS";

export const UPDATE_CURRENCY = "UPDATE_CURRENCY";
export const UPDATE_PRICE_INVENTORY = "UPDATE_PRICE_INVENTORY";
export const REQUEST_BASKET_AFTER_ADDING_TO_CART =
  "REQUEST_BASKET_AFTER_ADDING_TO_CART";
export const SUPPLIER_INFO_SUCCESS = "SUPPLIER_INFO_SUCCESS";
export const ADD_TO_CART_MODAL_CLOSE = "ADD_TO_CART_MODAL_CLOSE";
export const SET_CART_VALIDATION_ERR = "SET_CART_VALIDATION_ERR";
export const SET_PRODUCT_OUT_OF_STOCK_ERR = "SET_PRODUCT_OUT_OF_STOCK_ERR";

export const CHANGE_PRODUCT_ATTRIBUTES = "CHANGE_PRODUCT_ATTRIBUTES";
export const SET_ATTRIBUTES_DETAILS = "SET_ATTRIBUTES_DETAILS";
export const SET_PRODUCT_SWITCH_IMAGE_FLAG = "SET_PRODUCT_SWITCH_IMAGE_FLAG";
export const SET_PRODUCT_IMAGECAROUSEL_INITIAL =
  "SET_PRODUCT_IMAGECAROUSEL_INITIAL";

export const FETCH_STORES_REQUEST = "FETCH_STORES_REQUEST";
export const FETCH_STORES_REQUEST_SAGA = "FETCH_STORES_REQUEST_SAGA";
export const FETCH_STORES_SUCCESS = "FETCH_STORES_SUCCESS";
export const FETCH_STORES_FAILURE = "FETCH_STORES_FAILURE";
export const SET_SELECTED_STORE = "SET_SELECTED_STORE";
export const SET_STORES_NAVCAT = "SET_STORES_NAVCAT";

export const CHANGE_ENTRY_STATE = "CHANGE_ENTRY_STATE";
export const CHANGE_LANGUAGE_FROM_FUNCTION = "CHANGE_LANGUAGE_FROM_FUNCTION";

export const CHANGE_TITLE_AND_LONGDESC = "CHANGE_TITLE_AND_LONGDESC";
export const SHOW_CONTINUE_MODAL = "SHOW_CONTINUE_MODAL";

export const BACK_TO_CATEGORY_REQUEST = "BACK_TO_CATEGORY_REQUEST";
export const BACK_TO_CATEGORY_FINISH = "BACK_TO_CATEGORY_FINISH";

export const FETCH_CURRENCY_LIST = "FETCH_CURRENCY_LIST";

export const CHANGE_COUNTRY = "CHANGE_COUNTRY";

export const COOKIE_WINDOW_SHOW = "COOKIE_WINDOW_SHOW";
export const SHOW_CONTINUE_MODAL_QUOTE = "SHOW_CONTINUE_MODAL_QUOTE";

export const POPULATE_ACCESSORY_MODAL = "POPULATE_ACCESSORY_MODAL";
export const CLOSE_ACCESSORY_MODAL = "CLOSE_ACCESSORY_MODAL";
export const GET_MODAL_ITEM_FETCH_REQUEST = "GET_MODAL_ITEM_FETCH_REQUEST";
export const GET_MODAL_ITEM_FETCH_SUCCESS = "GET_MODAL_ITEM_FETCH_SUCCESS";

export const SHOW_CONFIRM = "SHOW_CONFIRM";
export const HIDE_CONFIRM = "HIDE_CONFIRM";

export const deliveryOptionsActions = {
  REQUEST_DELIVERY_OPTIONS: "REQUEST_DELIVERY_OPTIONS",
  SUCCESS_DELIVERY_OPTIONS: "SUCCESS_DELIVERY_OPTIONS",
  FAILURE_DELIVERY_OPTIONS: "FAILURE_DELIVERY_OPTIONS"
};

export const addToCartActions = {
  REQUEST_ADD_TO_CART: "REQUEST_ADD_TO_CART",
  SUCCESS_ADD_TO_CART: "SUCCESS_ADD_TO_CART",
  FAILURE_ADD_TO_CART: "FAILURE_ADD_TO_CART"
};

export const confirmActions = {
  CONFIRM_YES: "CONFIRM_YES",
  CONFIRM_NO: "CONFIRM_NO"
};

export const featuredMenuActions = {
  REQUEST_FEATURED_MENU: "REQUEST_FEATURED_MENU",
  SUCCESS_FEATURED_MENU: "SUCCESS_FEATURED_MENU",
  FAILURE_FEATURED_MENU: "FAILURE_FEATURED_MENU"
};

export const SET_FEATURED_PRODUCTS = "SET_FEATURED_PRODUCTS";

export const SET_DISCOUNT_RATE = "SET_DISCOUNT_RATE";

export const UPDATE_ACCESSORY_INVENTORY = "UPDATE_ACCESSORY_INVENTORY";
